// @ts-ignore
import cookie from 'cookie';
import {perr} from 'hola_pub_util';
import {use_agree_dialog} from '../use_agree_dialog';
import {use_campaign} from '../use_campaign';
import {use_download} from '../../shared/use_download';
import {Haff_agree_dialog} from './agree_dialog';

interface i_use_haff_download_props {
    perr_pref: string;
    on_download?: ()=>void;
    force_vpn_dl?: boolean;
}

export const use_haff_download = (props: i_use_haff_download_props)=>{
    const {perr_pref, on_download, force_vpn_dl} = props;
    const cmp = use_campaign();
    const need_agree = cmp?.consent_on_lp;
    const {download, download_br, do_agree,
        get_filename} = use_download({need_agree});
    const filename = get_filename({hola_browser: !cookie.get('c_vpn')});
    const [toggle, Agree_dialog] = use_agree_dialog({on_agree: do_agree,
        agree_dialog: Haff_agree_dialog});
    const handle_download = e=>{
        e.preventDefault();
        on_download && on_download();
        perr({id: `www_haffnetwork_${perr_pref}_click_btn`});
        if (need_agree)
            toggle(true);
        let c_vpn = cookie.get('c_vpn');
        if (c_vpn || force_vpn_dl)
        {
            download();
            return;
        }
        download_br();
    };
    return {handle_download, filename, Agree_dialog};
};
